import { size, toString } from 'es-toolkit/compat';
import * as React from 'react';

import { TextInput, TextInputProps } from './TextInput';

interface Props extends TextInputProps {
  filter?: InputFilter;
}

interface State {
  formattedValue: string;
}

/**
 * @deprecated
 * Plase see ui folder of your project
 */
export class FormattedTextInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { filter, value } = props;

    this.state = {
      formattedValue:
        value && value.length > 0 ? (filter ? toString(filter.formatModelValue(value)) : '') : '',
    };
  }

  componentDidUpdate(prevProps: Props) {
    const { filter, value } = this.props;
    // if the form gets reset, or goes to zero
    if (size(prevProps.value) > 0 && size(value) === 0) {
      if (filter && value) {
        const modelValue = filter.parseViewValue(value);
        const newViewValue = filter.formatModelValue(modelValue);
        this.setState({
          formattedValue: newViewValue as string,
        });
      } else {
        this.setState({
          formattedValue: value || '',
        });
      }
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { filter, onChange } = this.props;

    if (filter) {
      if (filter.formatOnChange) {
        const modelValue = filter.parseViewValue(event.target.value);
        const newViewValue = filter.formatModelValue(modelValue);
        this.setState({
          formattedValue: newViewValue as string,
        });
      } else {
        this.setState({
          formattedValue: event.target.value,
        });
      }

      if (onChange) {
        onChange(event);
      }
    } else {
      if (onChange) {
        onChange(event);
      }
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { filter, onBlur } = this.props;

    /// Create a formatted text input wrapper
    if (filter) {
      const modelValue = filter.parseViewValue(event.target.value);
      const newViewValue = filter.formatModelValue(modelValue);

      this.setState({
        formattedValue: newViewValue as string,
      });
      if (onBlur) {
        onBlur(event);
      }
    } else {
      this.setState({
        formattedValue: event.target.value,
      });
      if (onBlur) {
        onBlur(event);
      }
    }
  };

  render() {
    const { filter, onChange, onBlur, value, ...props } = this.props;

    const { formattedValue } = this.state;

    return (
      <TextInput
        {...props}
        value={filter ? formattedValue : value}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}
